var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Multiselect',{ref:"selector",attrs:{"searchable":"","multiple":"","value":_vm.value,"options":_vm.documents,"custom-label":_vm.name,"track-by":"id","placeholder":"Documents","block-keys":['Backspace', 'Delete']},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }